


























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import superAdminStore from "@/store/modules/SuperAdminStore";
import { appModule } from "@/store/modules/app";
import { pusher } from "@/services/PusherClient";
import TrendChart from "@/pages/SuperAdmin/SuperAdminTrendChart.vue";

const REFRESH_MS = 60000;

@Component({ components: { TrendChart } })
export default class SuperAdminDashboardPage extends Vue {
  autoRefresh = true;
  private timer: number | null = null;
  private pusherChannel = "pemeriksaan.unit.01";

  get loading(): boolean {
    return superAdminStore.loading;
  }

  get exporting(): boolean {
    return superAdminStore.exporting;
  }

  get overview() {
    return superAdminStore.overview;
  }

  get trendDataSet() {
    const t = this.overview?.trend || [];
    return {
      labels: t.map(x => x.label),
      ralan: t.map(x => x.ralan),
      igd: t.map(x => x.igd),
      ranap: t.map(x => x.ranap)
    };
  }

  async mounted() {
    await this.refresh();
    this.startAutoRefresh();
    this.bindRealtime();
  }

  beforeDestroy() {
    this.stopAutoRefresh();
    try {
      pusher.unsubscribe(this.pusherChannel);
    } catch (e) {
      /* noop */
    }
  }

  async refresh() {
    try {
      await superAdminStore.loadOverview();
    } catch (e) {
      /* error sudah ditangani service */
    }
  }

  startAutoRefresh() {
    this.stopAutoRefresh();
    this.timer = window.setInterval(() => {
      if (this.autoRefresh) this.refresh();
    }, REFRESH_MS);
  }

  stopAutoRefresh() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  /** Push-driven refresh pada event paling aktif (IGD), fallback ke polling. */
  bindRealtime() {
    try {
      pusher.subscribe(this.pusherChannel);
      pusher.bind("resume-ralan-created", () => this.refresh());
      pusher.bind("igd-administrasi-selesai", () => this.refresh());
    } catch (e) {
      /* pusher opsional — polling tetap jalan */
    }
  }

  async doExport(
    dataset: "users" | "logins" | "census" | "visits",
    format: string
  ) {
    try {
      if (dataset === "users") {
        await superAdminStore.exportUsers(format);
      } else if (dataset === "logins") {
        await superAdminStore.exportLogins({ format });
      } else if (dataset === "census") {
        await superAdminStore.exportCensus(format);
      } else {
        await superAdminStore.exportVisits({ format });
      }
      appModule.NoticeDelay("Ekspor sedang diunduh");
    } catch (e) {
      /* error sudah ditangani service */
    }
  }

  goto(name: string) {
    if (this.$route.name !== name) this.$router.push({ name });
  }

  formatTime(v: string | null): string {
    return v ? moment(v).format("DD-MM-YYYY HH:mm:ss") : "-";
  }
}
